import { CompositeEditorProps, default as CompositeEditorType } from './components/CompositeEditor';
import IEditor from './components/IEditor';
import { ReactEditorProps } from './components/ReactEditor';
import PluginViewStateAdapter from './store/schema/PluginViewStateAdapter';
import { createLazyComponent, LazyImport, LazyModule, LazyModuleType } from 'owa-bundling';
export { ComponentClass } from 'react';
export { default as EditorPluginEx } from './store/schema/EditorPluginEx';
export { default as PluginUtils } from './store/schema/PluginUtils';
export { default as PluginWithViewState } from './store/schema/PluginWithViewState';
export { default as PluginWithUI } from './store/schema/PluginWithUI';
export { OperateContentType } from './utils/operateContent';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "HtmlEditor" */ './lazyIndex'));

export let ReactEditor = createLazyComponent<
    ReactEditorProps,
    LazyModuleType<typeof lazyModule>,
    IEditor
>(lazyModule, m => m.ReactEditor);
export let CompositeEditor = createLazyComponent<
    CompositeEditorProps,
    LazyModuleType<typeof lazyModule>,
    CompositeEditorType
>(lazyModule, m => m.CompositeEditor);

export let lazySetTableHeaderRow = new LazyImport(lazyModule, m => m.setTableHeaderRow);
export let lazyOperateContent = new LazyImport(lazyModule, m => m.operateContent);

export { IEditor, ReactEditorProps, CompositeEditorProps, PluginViewStateAdapter };
